export const esc = (s) => String(s)
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;');

export const productsUrl = window.kcaData?.productsUrl
  ?? '/wp-json/kca/v1/products';

export const PER_PAGE = 12;

export const arrowSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="24"
  height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
  aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12"/>
  <polyline points="12 5 19 12 12 19"/></svg>`;

export const xSvg = `<svg xmlns="http://www.w3.org/2000/svg" fill="none"
  class="icon icon-close-small" viewBox="0 0 12 13" width="11"
  height="11" aria-hidden="true"><path stroke="currentColor"
  stroke-linecap="round" stroke-linejoin="round"
  d="M8.486 9.33 2.828 3.67M2.885 9.385l5.544-5.77"/></svg>`;

export const productCard = (p) => {
  const img = p.thumbnail
    ? `<div class="products-listing__image">`
      + `<img src="${esc(p.thumbnail)}" alt="${esc(p.title)}"></div>`
    : '<div class="products-listing__image'
      + ' products-listing__image--placeholder"></div>';
  return [
    '<li class="products-listing__item" role="listitem">',
    `<a href="${esc(p.link)}" class="products-listing__card">`,
    img,
    '<div class="products-listing__info">',
    `<h3 class="products-listing__title">${esc(p.title)}</h3>`,
    '</div>',
    '<div class="wp-block-button is-style-filled-red">',
    '<span class="wp-block-button__link">',
    `View details ${arrowSvg}`,
    '</span></div>',
    '</a></li>',
  ].join('');
};

export const updateDropdownCounts = (checkboxSel) => {
  document.querySelectorAll('.search-results__dropdown').forEach((dropdown) => {
    const count = dropdown.querySelectorAll(`${checkboxSel}:checked`).length;
    const dropCountEl = dropdown
      .querySelector('.search-results__dropdown-count');
    if (dropCountEl) dropCountEl.textContent = `${count} selected`;
  });
};

export const initChipRemove = (checkboxSel, onRemove) => {
  document.addEventListener('click', (e) => {
    const chip = e.target.closest('.search-results__chip');
    if (!chip) return;
    const { taxonomy, slug } = chip.dataset;
    const cb = document.querySelector(
      `${checkboxSel}[data-taxonomy="${taxonomy}"][data-slug="${slug}"]`,
    );
    if (cb) cb.checked = false;
    onRemove();
  });
};

export const initDropdownReset = (checkboxSel, onReset) => {
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.search-results__dropdown-reset-inner');
    if (!btn) return;
    btn.closest('.search-results__dropdown')
      ?.querySelectorAll(`${checkboxSel}:checked`)
      .forEach((cb) => { cb.checked = false; });
    onReset();
  });
};

export const initDropdowns = () => {
  const SEL = '.search-results__dropdown';
  const SEL_BTN = `${SEL}-btn`;
  const SEL_PANEL = `${SEL}-panel`;

  document.querySelectorAll(SEL).forEach((dropdown) => {
    const btn = dropdown.querySelector(SEL_BTN);
    const panel = dropdown.querySelector(SEL_PANEL);
    if (!btn || !panel) return;

    btn.addEventListener('click', () => {
      const isOpen = btn.getAttribute('aria-expanded') === 'true';
      document.querySelectorAll(SEL_BTN).forEach((b) => {
        b.setAttribute('aria-expanded', 'false');
        b.closest(SEL)?.querySelector(SEL_PANEL)?.setAttribute('hidden', '');
      });
      if (!isOpen) {
        btn.setAttribute('aria-expanded', 'true');
        panel.removeAttribute('hidden');
      }
    });
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest(SEL)) {
      document.querySelectorAll(SEL_BTN).forEach((b) => {
        b.setAttribute('aria-expanded', 'false');
      });
      document.querySelectorAll(SEL_PANEL).forEach((p) => {
        p.setAttribute('hidden', '');
      });
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll(SEL_BTN).forEach((b) => {
      b.setAttribute('aria-expanded', 'false');
    });
    document.querySelectorAll(SEL_PANEL).forEach((p) => {
      p.setAttribute('hidden', '');
    });
  });
};
